import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import RoutePolyline from './RoutePolyline';
import { useEffect, useState } from 'react';
import MomentMarker from './MomentMarker';

// MapView Component
const MapView = ({ routeCoordinates, rideId, moments, selectedMoment, onSelectMoment }) => {
  const [mapInstance, setMapInstance] = useState(null);

  const MapContent = () => {
    const map = useMap();

    useEffect(() => {
      if (map) { 
        // console.log("Map reference obtained")
        setMapInstance(map)
        if (selectedMoment && selectedMoment.latitude && selectedMoment.longitude) {
          map.setCenter({lat: selectedMoment.latitude, lng: selectedMoment.longitude})
        }
      }
    }, [map]);

    return null;
  }
  

  const mapOptions = {
    mapId: process.env.REACT_APP_DAY_MAP_ID || '',
    disableDefaultUI: false,
    clickableIcons: false,
    defaultCenter: {lat: 12.9716, lng: 77.5946}, // Default to Bangalore
    defaultZoom: 16,
    reuseMaps: true
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
        <Map 
          options={mapOptions} 
          style={{ width: '100%', height: '100%' }}
        >
          <MapContent />
          {mapInstance &&
            <RoutePolyline 
              coordinates={routeCoordinates} 
              mapInstance={mapInstance}
              key={rideId}
            />
          }
          {moments && moments.map((moment) => (
            <MomentMarker 
              key={moment.id} 
              moment={moment} 
              isSelected={selectedMoment && selectedMoment.id === moment.id} 
              onSelectMoment={onSelectMoment}
            />
          ))}
        </Map>
      </APIProvider>
    </div>
  );
};

export default MapView;